// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/dsaActions';
import Button from '../common/Button';
//css
import '../../styles/components/goals/GoalQuestionForm.scss';


class GoalQuestionForm extends Component {

  render() {
    const { question, updateDSAGoalAnswer, dsaGoals } = this.props;
    // Find the selected answer for this question in the dsa goals list for this dsa
    const ag = dsaGoals.find(g => g.goal === question.id);
    const handleClick = (value) => {
      if (value !== ag.answer) updateDSAGoalAnswer(ag.id, value);
    };

    return (
      <div className='goal-question-form'>
        <div className='goal-question-form-header'>
          <h7 className='question-title'>{ question.title || 'Question needs a title...' }</h7>
          { question.description && question.description.length &&
            <p className='h7 light'>
              { question.description }
            </p>
          }
        </div>
        <div className='goal-question-form-options'>
          <Button onClick={handleClick.bind(this, 0) /* eslint-disable-line react/jsx-no-bind */} label='No' primary={ag.answer === 0} />
          <Button onClick={handleClick.bind(this, 1) /* eslint-disable-line react/jsx-no-bind */} label='Yes' primary={ag.answer === 1} />
        </div>
      </div>
    );
  }
}

GoalQuestionForm.propTypes = {
  question: PropTypes.object,
  dsaGoals: PropTypes.array,
  updateDSAGoalAnswer: PropTypes.func
};

const mapStateToProps = (state) => {
  const props = {
    dsaGoals: state.dsa.dsaGoals
  };
  return props;
};
const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(GoalQuestionForm);



// WEBPACK FOOTER //
// ./src/components/goals/GoalQuestionForm.js